<div
  class="client-profile-container"
  *ngIf="clientData !== null"
  id="div_client-profile-container_470574bf"
>
  <div class="client-profile-sidebar" id="div_client-profile-sidebar_b6994695">
    <div class="radial-bg" id="div_radial-bg_8ba201d3">
      <div class="sidebar-info" id="div_sidebar-info_8b704a1b">
        <img
          aria-label="User Icon"
          title="User Icon"
          class="user-icon"
          alt="User Icon"
          src="../../../assets/icons/account-circle.svg"
          id="img_user-icon_85185463"
        />

        <div class="name-paragraph" id="div_name-paragraph_25f034d8">
          Hello, {{ clientData['contact-info'].name.split(' ')[0] }}.
        </div>
      </div>
      <div class="side-navigation" id="div_side-navigation_191402b4">
        <div
          [ngClass]="tab == '1' ? 'active' : ''"
          (click)="changeTab('1')"
          id="div_f7037bc3"
        >
          <p id="p_7e1b3012">Account Information</p>
          <img
            aria-label="Right Arrow"
            title="Right Arrow"
            src="assets/icons/chevron-right.svg"
            alt="Right Arrow Icon"
            id="img_3d9e55e1"
          />
        </div>
        <div
          [ngClass]="tab == '2' ? 'active' : ''"
          (click)="changeTab('2')"
          id="div_85743bae"
        >
          <p id="p_85e7da71">Account Activity</p>
          <img
            aria-label="Right Arrow"
            title="Right Arrow"
            src="assets/icons/chevron-right.svg"
            alt="Right Arrow Icon"
            id="img_98f9cadf"
          />
        </div>
        <div
          [ngClass]="tab == '3' ? 'active' : ''"
          (click)="changeTab('3')"
          id="div_e3bea742"
        >
          <p id="p_18596f1c">SDS Repository</p>
          <img
            aria-label="Right Arrow"
            title="Right Arrow"
            src="assets/icons/chevron-right.svg"
            alt="Right Arrow Icon"
            id="img_23d4ec3f"
          />
        </div>
      </div>
    </div>
  </div>

  <div
    [ngClass]="
      tab == '2' ? 'client-card-container-lg' : 'client-card-container'
    "
    id="div_cade5aca"
  >
    <div class="client-card" id="div_client-card_2eb8fa41">
      <div
        [ngClass]="tab == '1' ? 'card-inside' : 'card-inside-p'"
        id="div_d32d16ca"
      >
        <div *ngIf="tab == '1'" class="section-1" id="div_section-1_0d660c35">
          <div id="div_9062fa7a">
            <div
              class="client-page-heading"
              id="div_client-page-heading_4ad08a2b"
            >
              Account Information
            </div>
            <h6 class="client-info-header" id="h6_client-info-header_80f334b1">
              Contact Information
            </h6>
            <div class="divider" id="div_divider_b8c5e1d3"></div>

            <div class="info-paragraph" id="div_info-paragraph_71ebcf58">
              <p id="p_cb6f7f7d">{{ clientData['contact-info'].name }}</p>
              <p id="p_b59ca12c">{{ clientData['contact-info'].email }}</p>
              <p id="p_77c89570">{{ clientData['contact-info'].phone }}</p>
            </div>

            <div
              style="margin-top: 40px"
              class="client-info-header"
              id="div_client-info-header_cb2dd915"
            >
              Company Information
            </div>
            <div class="divider" id="div_divider_03a35516"></div>
            <div class="info-paragraph" id="div_info-paragraph_e1aac409">
              <ng-container
                *ngIf="clientData['company-info'].name"
                id="ng-container_3a13a61c"
              >
                {{ clientData['company-info'].name }}
                <br />
              </ng-container>

              <ng-container
                *ngIf="clientData['company-info'].address.street"
                id="ng-container_05cab7ce"
              >
                {{ clientData['company-info'].address.street }}
                <br />
              </ng-container>

              <ng-container
                *ngIf="clientData['company-info'].address.city"
                id="ng-container_59588959"
              >
                {{ clientData['company-info'].address.city }}
                <ng-container
                  *ngIf="clientData['company-info'].address.state"
                  id="ng-container_f70c1709"
                >
                  {{ ',' }}
                </ng-container>
              </ng-container>

              <ng-container
                *ngIf="clientData['company-info'].address.state"
                id="ng-container_3a660cde"
              >
                {{ clientData['company-info'].address.state }}
                <br />
              </ng-container>

              <ng-container
                *ngIf="clientData['company-info'].address['postal-code']"
                id="ng-container_785e7f90"
              >
                {{ clientData['company-info'].address['postal-code'] }}
                <br />
              </ng-container>

              <ng-container
                *ngIf="clientData['company-info'].address.country !== null"
                id="ng-container_0c43f203"
              >
                {{ clientData['company-info'].address.country }}
              </ng-container>
            </div>
          </div>
          <div id="div_37f57447">
            <div class="contact-paragraph" id="div_contact-paragraph_22b10032">
              Is your information incomplete or incorrect?<br />
              <a
                class="info-link"
                target="_blank"
                href="https://trinityrail.com/contact"
                aria-label="Contact us to get it corrected"
                title="Contact us to get it corrected"
                id="a_info-link_ff64bc1c"
                >Contact us</a
              >
              to get it corrected.
            </div>
          </div>
        </div>
        <div *ngIf="tab == '3'" class="section-3" id="div_section-3_7d69a5be">
          <div class="d-flex flex-column" id="div_d-flex_81b2fe1d">
            <div
              class="d-flex justify-content-between padding-40"
              id="div_d-flex_991e46a6"
            >
              <div id="div_0c8f3e26">
                <p
                  aria-label=" Please upload a current Safety Data Sheet"
                  title=" Please upload a current Safety Data Sheet"
                  class="text-file-head mb-1"
                  id="p_text-file-head_59b6546d"
                >
                  Please upload a current Safety Data Sheet (SDS).
                </p>
                <p
                  aria-label="An SDS is required for all tank cars and hazardous materials"
                  title="An SDS is required for all tank cars and hazardous materials"
                  class="text-file-sub"
                  id="p_text-file-sub_4b22e466"
                >
                  An SDS is required for all tank cars and hazardous materials.
                </p>
                <!-- <button (click)="fileDropRef.click()" class="browse-btn">browse computer</button> -->
                <div *ngIf="showingFileList" id="div_c33927f2">
                  <div class="files-list" id="div_files-list_0edabc36">
                    <div
                      class="single-file d-flex"
                      *ngFor="let file of files; let i = index"
                      id="div_single-file_e4827f4b"
                    >
                      <div
                        class="delete"
                        (click)="deleteFile(i)"
                        id="div_delete_eb1cdc28"
                      >
                        <img
                          src="../../../assets/icons/close.svg"
                          width="30"
                          height="30"
                          alt="Delete"
                          aria-label="Delete this file"
                          title="Delete this file"
                          id="img_a786a533"
                        />
                      </div>
                      <div class="info" id="div_info_82ce07af">
                        <h4
                          class="name-tag"
                          [title]="file.sds_name"
                          id="h4_name-tag_23ab6afe"
                        >
                          <img
                            src="../../../assets/icons/picture-as-pdf.svg"
                            alt="PDF Icon"
                            aria-label="PDF Icon"
                            title="PDF Icon"
                            id="img_52e6fe8e"
                          />
                          <span
                            [textContent]="
                              file.file_name.length > 40
                                ? (file.file_name | slice: 0 : 40) + '...'
                                : file.file_name
                            "
                            id="span_625be055"
                          ></span>
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    (click)="getAwsURL()"
                    class="header-btn mt-3"
                    [ngClass]="files.length ? 'btn-active' : 'btn-inactive'"
                    id="div_header-btn_e22c3a4e"
                  >
                    <span
                      class="header-btn-txt"
                      id="span_header-btn-txt_b7e17457"
                      >Upload Files</span
                    >
                  </div>
                </div>
              </div>
              <div id="div_3584834e">
                <div
                  fxLayout="column"
                  fxLayoutAlign="center center"
                  class="info-paragraph row-spacing"
                  id="div_info-paragraph_a36bf422"
                >
                  <div class="upload-panel" id="div_upload-panel_f49d4882">
                    <div
                      class="dnd-container"
                      appDnd=""
                      id="div_dnd-container_d3ef24da"
                    >
                      <input
                        class="cursor"
                        multiple=""
                        type="file"
                        #fileDropRef=""
                        id="fileDropRef"
                        (click)="canUploadSDSFile($event)"
                        accept="application/pdf"
                        (change)="fileBrowseHandler($event.target)"
                      />

                      <img
                        alt="upload"
                        aria-label="upload"
                        title="upload"
                        src="../../../assets/icons/cloud-upload.svg"
                        id="img_f7dd19b3"
                      />
                      <h6 class="cursor" id="h6_cursor_9eed580a">
                        DRAG & DROP FILE
                      </h6>
                      <small
                        class="small-ref"
                        for="fileDropRef"
                        id="small_small-ref_eaebd1ec"
                        >Supported format: PDF</small
                      ><br /><br />
                      <span class="browse-btn" id="span_browse-btn_4756d55b"
                        >browse computer</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="div_153e8f13">
              <div id="div_12052848">
                <div
                  class="d-flex justify-content-between my-3 padding-40"
                  id="div_d-flex_9f1c9956"
                >
                  <div class="text-recent" id="div_text-recent_dd2dcd8f">
                    Files({{ sdsFileList.length }})
                  </div>
                  <div id="div_f1b0a7f0">
                    <div
                      (click)="sortSDSFile(sdsFileList)"
                      [ngClass]="isSort ? 'recent-btn-active' : 'recent-btn'"
                      class="cursor"
                      id="div_cursor_7ab4c385"
                    >
                      <img
                        width="20"
                        height="20"
                        [src]="
                          isSort
                            ? '/assets/icons/access-time-active.svg'
                            : '/assets/icons/access-time.svg'
                        "
                        alt="Sort Icon"
                        aria-label="Sort Icon"
                        title="Sort Icon"
                        id="img_55f374e7"
                      />
                      {{
                        isSort ? 'oldest - most recent' : 'most recent - oldest'
                      }}
                    </div>
                  </div>
                </div>

                <p-table
                  styleClass="p-datatable-striped"
                  [value]="sdsFileList"
                  id="p-table_bbed726f"
                >
                  <ng-template
                    pTemplate="body"
                    let-files=""
                    id="ng-template_40dc9b5c"
                  >
                    <tr id="tr_63f0fc52">
                      <td
                        style="padding-right: 0px; width: 82%"
                        id="td_6039a364"
                      >
                        <div id="div_bfb2ce65">
                          <table id="table_c1ccb5fd">
                            <thead id="thead_bf5b0d5f">
                              <tr
                                class="table-heading-file"
                                id="tr_table-heading-file_47db7c0e"
                              >
                                <th id="th_94f4437b">File Name</th>
                                <th id="th_0a55f09e">Upload Date</th>
                                <th id="th_05820314">Size</th>
                              </tr>
                            </thead>
                            <tbody id="tbody_73255b3d">
                              <tr id="tr_2d90caaf">
                                <td
                                  class="truncate-text"
                                  id="td_truncate-text_6f2b7ce7"
                                >
                                  <img
                                    src="../../../assets/icons/insert-drive-file.svg"
                                    alt="File Icon"
                                    aria-hidden="true"
                                    aria-label="File Icon"
                                    title="File Icon"
                                    id="img_ce4553a0"
                                  />
                                  <a
                                    class="text-file-name"
                                    title="Download File"
                                    aria-label="Download File"
                                    style="text-decoration: none"
                                    target="_blank"
                                    href="{{
                                      files?.files?.file_path?.split(
                                        '?Content-Type=application'
                                      )[0]
                                    }}"
                                    id="a_text-file-name_72e48657"
                                    >{{ files?.files?.file_name }}</a
                                  >
                                </td>
                                <td class="text-td" id="td_text-td_56a602fc">
                                  {{ files?.created_date | date: 'mediumDate' }}
                                </td>
                                <td class="text-td" id="td_text-td_a65e7358">
                                  {{
                                    calculateFileSize(files?.files?.sds_data)
                                  }}MB
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                      <td style="padding-left: 0px" id="td_5f2f4843">
                        <div
                          class="d-flex justify-content-end"
                          id="div_d-flex_a8d1d1f5"
                        >
                          <img
                            class="cursor"
                            (click)="
                              openDownloadModall(files?.files?.file_path)
                            "
                            src="../../../assets/icons/table-download.svg"
                            alt="Download Icon"
                            title="Download File"
                            aria-label="Download File"
                            id="img_cursor_273d1bb0"
                          />

                          <img
                            class="cursor"
                            style="margin-left: 10px"
                            (click)="deleteFileFromList(files)"
                            src="../../../assets/icons/table-delete.svg"
                            alt="Delete Icon"
                            title="Delete File"
                            aria-label="Delete File"
                            id="img_cursor_22720028"
                          />
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="tab == '2'" class="section 2" id="div_section_be6d8669">
          <div
            class="client-page-heading padding-40"
            id="div_client-page-heading_5fc31842"
          >
            Recent Quote Submissions
          </div>
          <div
            class="d-flex justify-content-between my-4 padding-40"
            id="div_d-flex_ef954664"
          >
            <div class="text-recent" id="div_text-recent_373df359">
              quotes({{ searchHistory?.length }})
            </div>
            <div class="d-flex width-480" id="div_d-flex_ac7421bc">
              <div *ngIf="isMostRecentOldest" id="div_900908f3">
                <div class="mx-2" id="div_mx-2_e7b9ef1c">
                  <div
                    class="recent-btn cursor"
                    (click)="filteredList('sorting', 'new')"
                    id="div_recent-btn_18b49394"
                  >
                    <img
                      width="20"
                      height="20"
                      [src]="'/assets/icons/access-time.svg'"
                      alt="Access Time Icon"
                      title="Access Time"
                      aria-label="Access Time Icon"
                      id="img_00442414"
                    />
                    most recent - oldest
                  </div>
                </div>
              </div>
              <div
                *ngIf="!isMostRecentOldest"
                class="mx-2"
                id="div_mx-2_f9b2dded"
              >
                <div id="div_418a8679">
                  <div
                    class="recent-btn-active cursor"
                    (click)="filteredList('sorting', 'old')"
                    id="div_recent-btn-active_f90fbc5f"
                  >
                    <img
                      width="20"
                      height="20"
                      [src]="'/assets/icons/access-time-active.svg'"
                      alt="Active Access Time Icon"
                      title="Active Access Time"
                      aria-label="Active Access Time Icon"
                      id="img_0eec1019"
                    />
                    oldest - most recent
                  </div>
                </div>
              </div>
              <div id="div_59f118f2">
                <div
                  *ngIf="isAlert"
                  class="recent-btn-active cursor"
                  (click)="filteredList('alert')"
                  id="div_recent-btn-active_5c3fa275"
                >
                  <img
                    width="20"
                    height="20"
                    style="color: #ffffff"
                    [src]="'/assets/icons/white-bell.svg'"
                    alt="White Bell Icon"
                    title="White Bell"
                    aria-label="White Bell Icon"
                    id="img_09058210"
                  />
                  Alerts
                </div>
                <div
                  *ngIf="!isAlert"
                  class="recent-btn cursor"
                  (click)="filteredList('alert')"
                  id="div_recent-btn_8bb81354"
                >
                  <img
                    width="20"
                    height="20"
                    [src]="'/assets/icons/notifications-on.svg'"
                    alt="Notifications On Icon"
                    title="Notifications On"
                    aria-label="Notifications On Icon"
                    id="img_022e8b89"
                  />
                  Alerts
                </div>
              </div>
              <div id="div_1f624293">
                <div
                  *ngIf="isFavourite"
                  class="recent-btn-active cursor"
                  (click)="filteredList('favourite')"
                  id="div_recent-btn-active_47f971fc"
                >
                  <img
                    width="20"
                    height="20"
                    [src]="'/assets/icons/star.svg'"
                    alt="Star Icon"
                    title="Star Icon"
                    aria-label="Star Icon"
                    id="img_f08c1dbf"
                  />
                  Favorite
                </div>
                <div
                  *ngIf="!isFavourite"
                  class="recent-btn cursor"
                  (click)="filteredList('favourite')"
                  id="div_recent-btn_04a9e793"
                >
                  <img
                    width="20"
                    height="20"
                    [src]="'/assets/icons/star-active.svg'"
                    alt="Active Star Icon"
                    title="Active Star Icon"
                    aria-label="Active Star Icon"
                    id="img_cc3798a4"
                  />
                  Favorite
                </div>
              </div>
            </div>
          </div>
          <div class="" id="div_ab9a74d9">
            <p-table
              [paginator]="true"
              [rows]="10"
              styleClass="p-datatable-striped"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [rowsPerPageOptions]="[10, 15, 20]"
              [value]="searchHistory"
              id="p-table_77d653e1"
            >
              <ng-template pTemplate="header" id="ng-template_40cb5093">
              </ng-template>
              <ng-template
                pTemplate="body"
                let-item=""
                let-i="index"
                id="ng-template_c77b01d5"
              >
                <tr id="tr_42b0d544">
                  <td class="td-space" id="td_td-space_817f8b77">
                    <div
                      class="d-flex justify-content-between"
                      id="div_d-flex_e859cd32"
                    >
                      <img
                        width="24"
                        height="24"
                        class="cursor mx-2"
                        (click)="triggerupdateFavoriteApi(item)"
                        [src]="
                          item.is_quote_favorite
                            ? '/assets/icons/star-active.svg'
                            : '/assets/icons/favourite.svg'
                        "
                        alt="Favorite Icon"
                        aria-label="Favorite Icon"
                        title="Favorite Icon"
                        id="img_cursor_419fb87c"
                      />

                      <img
                        class="cursor"
                        (click)="toggleAlertRailcarInventory(item)"
                        [src]="
                          item.railcar_inventory_alert
                            ? '/assets/icons/notifications-on.svg'
                            : '/assets/icons/notifications.svg'
                        "
                        alt="Alert Icon"
                        aria-label="Alert Icon"
                        title="Alert Icon"
                        id="img_cursor_92f82bc2"
                      />
                    </div>

                    <div
                      style="width: 85%"
                      class="d-flex flex-column"
                      id="div_d-flex_70866c12"
                    >
                      <div class="stcc-heading" id="div_stcc-heading_ba3d73f0">
                        Product – STCC#
                        {{ item?.user_search_input['user-filter'].car_type }}
                      </div>
                      <div id="div_dffee926">
                        <table id="table_b23ceb05">
                          <thead id="thead_2f75defd">
                            <tr
                              class="text-subtable-header"
                              id="tr_text-subtable-header_5b10ea27"
                            >
                              <th id="th_e63e5410">Submission Date</th>
                              <th id="th_0db7eb49">Capacity (gal)</th>
                              <th id="th_bf7a804d">GRL (lbs)</th>
                              <th id="th_6d045d6a">Coils</th>
                              <th id="th_18a5fb69">Insulation</th>
                              <th id="th_71e77b64">Stencil Spec</th>
                              <th id="th_5e6c5f8f">Location</th>
                            </tr>
                          </thead>
                          <tbody id="tbody_0dc49b8c">
                            <tr
                              class="text-subtable-header"
                              id="tr_text-subtable-header_cda82855"
                            >
                              <td id="td_5347cd7d">
                                {{ item?.created_date | date: 'mediumDate' }}
                              </td>
                              <td id="td_d87270b4">
                                {{
                                  item?.user_search_input['selected-cars'][0]
                                    ?.capacity
                                }}
                              </td>
                              <td id="td_8edb3975">
                                {{
                                  item?.user_search_input['selected-cars'][0]
                                    ?.gross_rail_load
                                }}
                              </td>
                              <td id="td_f0bcd570">
                                {{
                                  item?.user_search_input['selected-cars'][0]
                                    ?.coils
                                }}
                              </td>
                              <td id="td_5e38f697">
                                {{
                                  item?.user_search_input['selected-cars'][0]
                                    ?.insulation
                                }}
                              </td>
                              <td id="td_b3e16501">
                                {{
                                  item?.user_search_input['selected-cars'][0]
                                    ?.stencil_spec
                                }}
                              </td>
                              <td id="td_9e106861">
                                {{
                                  item?.user_search_input['selected-cars'][0]
                                    ?.state +
                                    ',' +
                                    item?.user_search_input['selected-cars'][0]
                                      ?.country
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div
                      class="search-again-btn"
                      (click)="onLinkClick(item)"
                      id="div_search-again-btn_60a552b3"
                    >
                      Search again
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" id="ng-template_62e10677">
                <tr id="tr_2e1cbcb6">
                  <td class="text-center" id="td_text-center_7de51159">
                    No Information to Display
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="progress-spinner"
  *ngIf="loading"
  id="div_progress-spinner_dfc824d5"
>
  <p-progressSpinner
    styleClass="custom-spinner"
    id="p-progressSpinner_e2c80d48"
  ></p-progressSpinner>
</div>

<!-- Delete Modal  -->
<p-dialog
  [(visible)]="openDeleteModal"
  [closable]="true"
  [modal]="true"
  [style]="{ width: '475px', height: '330px' }"
  [draggable]="false"
  [resizable]="false"
  id="p-dialog_eb47a859"
>
  <div class="container text-center pt-1" id="div_container_ae6cfae7">
    <div class="row" id="div_row_e9cf931f">
      <div class="col-md-12" id="div_col-md-12_14f999ab">
        <h4
          class="fw-bold text-dark text-uppercase modal-heading"
          id="h4_fw-bold_a26ace23"
        >
          Delete File
        </h4>
      </div>
      <div id="div_72fd7962">
        <p
          aria-label="Are you sure you want to delete this file?"
          title="Are you sure you want to delete this file?"
          class="text-para"
          id="p_text-para_21a44899"
        >
          Are you sure you want to delete this file?
        </p>
      </div>
      <div
        class="d-flex flex-column py-3 justify-content-around align-items-center mx-auto"
        id="div_d-flex_f51a969e"
      >
        <button
          (click)="deleteApi()"
          type="button"
          class="btn-alert primary"
          id="button_btn-alert_7b15e4f6"
        >
          Yes
        </button>

        <button
          type="button"
          class="btn-alert outline"
          (click)="openDeleteModal = false"
          id="button_btn-alert_69834871"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Alert Modal -->
<p-dialog
  [(visible)]="toggleAlertRailcarInventoryModal"
  [closable]="true"
  [modal]="true"
  [style]="{ width: '475px', height: '330px' }"
  [draggable]="false"
  [resizable]="false"
  id="p-dialog_dcc44fdd"
>
  <div class="container text-center pt-1" id="div_container_2a62159a">
    <div class="row" id="div_row_5221f0e5">
      <div class="col-md-12" id="div_col-md-12_60c42c7b">
        <h4
          class="fw-bold text-dark text-uppercase modal-heading"
          id="h4_fw-bold_e58bc197"
        >
          Turn
          {{ dynamicData?.railcar_inventory_alert ? 'OFF' : 'On' }}
          Notification?
        </h4>
      </div>
      <div id="div_c6706aa8">
        <p
          class="text-para"
          [innerText]="
            dynamicData?.railcar_inventory_alert
              ? 'You will no longer receive email notifications about this product availability'
              : 'You will receive email notifications about this product availability'
          "
          id="p_text-para_fe9f92da"
        ></p>
      </div>
      <div
        class="d-flex flex-column py-3 justify-content-around align-items-center mx-auto"
        id="div_d-flex_86186893"
      >
        <button
          (click)="triggerAlertApi(dynamicData)"
          type="button"
          class="btn-alert primary"
          id="button_btn-alert_d25a8844"
        >
          Yes
        </button>

        <button
          type="button"
          class="btn-alert outline"
          (click)="closeAlertModal()"
          id="button_btn-alert_2e65bcf1"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Download Modal -->
<p-dialog
  [(visible)]="openDownloadModal"
  [closable]="true"
  [modal]="true"
  [style]="{ width: '475px', height: '330px' }"
  [draggable]="false"
  [resizable]="false"
  id="p-dialog_4dd4691c"
>
  <div class="container text-center pt-1" id="div_container_9251ba8a">
    <div class="row" id="div_row_ede191e7">
      <div class="col-md-12" id="div_col-md-12_709a7496">
        <h4
          class="fw-bold text-dark text-uppercase modal-heading"
          id="h4_fw-bold_cfded2ca"
        >
          Download File
        </h4>
      </div>
      <div id="div_164899c8">
        <p
          aria-label="Are you sure you want to download this file?"
          title="Are you sure you want to download this file?"
          class="text-para"
          id="p_text-para_aa9aad20"
        >
          Are you sure you want to download this file?
        </p>
      </div>
      <div
        class="d-flex flex-column py-3 justify-content-around align-items-center mx-auto"
        id="div_d-flex_83a2b9e7"
      >
        <button
          (click)="download()"
          type="button"
          class="btn-alert primary"
          id="button_btn-alert_f8f4ecce"
        >
          Yes
        </button>

        <button
          type="button"
          class="btn-alert outline"
          (click)="closeDownloadModal()"
          id="button_btn-alert_788beeb2"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Modal for more than 5 files -->
<p-dialog
  [(visible)]="moreFilesModal"
  [closable]="true"
  [modal]="true"
  [style]="{ width: '440px', height: '300px' }"
  [draggable]="false"
  [resizable]="false"
  id="p-dialog_233c504a"
>
  <div class="container text-center pt-1" id="div_container_cb691164">
    <div class="row" id="div_row_c42961e6">
      <div class="col-md-12" id="div_col-md-12_9127f8be">
        <h4
          class="fw-bold text-dark text-uppercase modal-heading"
          id="h4_fw-bold_a004c751"
        >
          Too Many Files
        </h4>
      </div>
      <div id="div_bae73bcc">
        <p
          aria-label="You may only have a maximum of 5 SDS files at one time"
          title="You may only have a maximum of 5 SDS files at one time"
          class="text-para"
          id="p_text-para_7aff98b9"
        >
          You may only have a maximum of 5 SDS files at one time
        </p>
      </div>
      <div
        class="d-flex flex-column py-3 justify-content-around align-items-center mx-auto"
        id="div_d-flex_2d6b98e6"
      >
        <button
          type="button"
          class="btn-alert outline"
          (click)="closeModal()"
          id="button_btn-alert_b76f8a5d"
        >
          OKAY
        </button>
      </div>
    </div>
  </div>
</p-dialog>
